import React from 'react';
import { Phone, Star } from 'lucide-react';
const HERO_IMG = 'https://cdn.magicpatterns.com/uploads/d2TLA4etwLg2JcwG5iqFpB/6ae0fc2f-6160-41c6-9db1-342c76651d46.jpg';
export function Hero() {
  return <section id="top" className="relative isolate w-full overflow-hidden" data-id="element-117" data-mp="9k0g9cbeknrr">
      <img src={HERO_IMG} alt="Arizona luxury home at dusk with warm landscape lighting on palm trees and pathway" className="absolute inset-0 h-full w-full object-cover" data-id="element-118" data-mp="4lyv8luf2edn" />
      <div className="absolute inset-0 bg-gradient-to-r from-background via-background/85 to-background/30" aria-hidden="true" data-id="element-119" data-mp="xanqi48sjphh" />

      <div className="relative mx-auto flex min-h-[640px] max-w-7xl flex-col justify-center px-4 py-24 sm:px-6 lg:min-h-[720px] lg:px-8" data-id="element-120" data-mp="sa9slf0wlvx6">
        <div className="max-w-2xl" data-id="element-121" data-mp="neavn31if5l5">
          <div className="mb-5 flex items-center gap-2" data-id="element-122" data-mp="3d21t5zvq8oos">
            <div className="flex" aria-hidden="true" data-id="element-123" data-mp="3czfms3kkof85">
              {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} className="h-4 w-4 fill-accent text-accent" data-id="element-124" data-mp="384s2yi0ik8zw" data-mpi={i} />)}
            </div>
            <span className="text-sm font-semibold uppercase tracking-wide text-muted-foreground" data-id="element-125" data-mp="3o7lv7zxu9mt6">
              5-Star Rated in Gilbert, AZ
            </span>
          </div>

          <h1 className="font-display text-5xl leading-[0.95] text-foreground drop-shadow-lg sm:text-6xl lg:text-7xl" data-id="element-126" data-mp="39cfkiznsszti">
            Light Up Your
            <br data-id="element-127" data-mp="30hrfnam4xk58" />
            <span className="text-accent" data-id="element-128" data-mp="30h9cdu1225nt">Arizona Nights</span>
          </h1>

          <p className="mt-6 max-w-xl border-l-4 border-accent bg-background/80 py-3 pl-5 pr-4 text-lg font-medium leading-relaxed text-foreground shadow-lg backdrop-blur-sm" data-id="element-129" data-mp="358zr0c70zfl1">
            Custom outdoor landscape lighting design and installation for Gilbert and the
            East Valley. We transform desert homes into warm, welcoming, and secure spaces
            after dark — built to last through every Arizona summer.
          </p>

          <div className="mt-9 flex flex-col gap-4 sm:flex-row" data-id="element-130" data-mp="2ljz2gp4297u7">
            <a href="#contact" className="rounded-md bg-accent px-8 py-4 text-center font-display text-lg tracking-wide text-accent-foreground transition-transform hover:scale-105" data-id="element-131" data-mp="s335tfryasyl">
              Get a Free Quote
            </a>
            <a href="tel:+14805550147" className="flex items-center justify-center gap-2 rounded-md border border-border bg-card/60 px-8 py-4 font-display text-lg tracking-wide text-foreground transition-colors hover:bg-card" data-id="element-132" data-mp="ddf3cb819o9a">
              <Phone className="h-5 w-5 text-accent" aria-hidden="true" data-id="element-133" data-mp="15zq35jntfl51" />
              (480) 555-0147
            </a>
          </div>
        </div>
      </div>
    </section>;
}